import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import FormControl from "@mui/material/FormControl";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

export default function Details ({ open, queryDetails, handleClose }) {
  const theme = useTheme();
  const color = { color: "rgba(0,0,0,0.7" };
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{"Custom battery Details"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(0,0,0,0.4)",
                borderRadius: "8px",
                padding: "6px",
              }}
            >
              <label style={color}>Basic Details</label>
              <div style={{ display: "flex", fontSize: "14px", gap: "16px" }}>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Name: </span>
                  {queryDetails?.name}
                </div>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Email: </span>
                  {queryDetails?.email}
                </div>
              </div>
              <div style={{ display: "flex", fontSize: "14px", gap: "16px" }}>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Number: </span>
                  {queryDetails?.number}
                </div>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Address: </span>
                  {queryDetails?.address}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(0,0,0,0.4)",
                borderRadius: "8px",
                padding: "6px",
                marginTop: "10px",
                fontSize: "14px",
              }}
            >
              <div style={{ display: "flex", padding: "5px 0" }}>
                <div style={{ display: "flex", width: "50%", flexDirection: "column" }}>
                  <label style={color}>Battery Chemistry</label>
                  {queryDetails?.batteryChemistry}
                </div>
                <div style={{ display: "flex", width: "50%", flexDirection: "column" }}>
                  <label style={color}>Cell Model</label>
                  {queryDetails?.preferredCellModel}
                </div>
              </div>
              <div style={{ display: "flex", padding: "5px 0" }}>
                <div style={{ display: "flex", width: "50%", flexDirection: "column" }}>
                  <label style={color}>Connector Type</label>
                  {queryDetails?.connectorType}
                </div>
                <div style={{ display: "flex", width: "50%", flexDirection: "column" }}>
                  <label style={color}>Quantity</label>
                  {queryDetails?.quantity}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", padding: "5px 0" }}>
                <label style={color}>Max Battery Pack Capacity (mAh)</label>
                {queryDetails?.batteryCapacity}
              </div>
              <div style={{ display: "flex", flexDirection: "column", padding: "5px 0" }}>
                <label style={color}>Nominal Battery Pack Voltage (V)</label>
                {queryDetails?.batteryVoltage}
              </div>
              <div style={{ display: "flex", flexDirection: "column", padding: "5px 0" }}>
                <label style={color}>Current Consumption Continuous (Amp)</label>
                {queryDetails?.currentConsumption}
              </div>
              <div style={{ display: "flex", flexDirection: "column", padding: "5px 0" }}>
                <label style={color}>Need Battery Management System (BMS)</label>
                {queryDetails?.bms ? "Yes" : "No"}
              </div>
              <div style={{ display: "flex", flexDirection: "column", padding: "5px 0" }}>
                <label style={color}>Battery Dimension (mm)</label>
                <div style={{display: 'flex'}}>
                  <div style={{width: '30%', fontSize: '12px'}}>
                    <div style={color}>Width </div>
                    {queryDetails?.batteryWidth}
                  </div>
                  <div style={{width: '30%', fontSize: '12px'}}>
                    <div style={color}>Height </div>
                    {queryDetails?.batteryHeight}
                  </div>
                  <div style={{width: '30%', fontSize: '12px'}}>
                    <div style={color}>Length </div>
                    {queryDetails?.batteryLength}
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", padding: "5px 0" }}>
                <label style={color}>Additional Note</label>
                {queryDetails?.additionalNote}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button autoFocus>
            Disagree
            </Button> */}
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    // marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "120px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};
